import React from 'react';
import { IconPlaySolid, Button, Mask, Transition } from '@smarterservices/smarter-ui';
import { getStore, usePlayerStore } from '../../../stores/StoreContext';
import Loader from '@ui/context/session/components/Common/Loader';

/**
 * Component to display a playback cover over the video player, with buttons to jump to the start of the video and change playback speed.
 * The buttons are displayed in a column, with the "Play" button at the top and the speed buttons below.
 * The component is wrapped in a Transition and Mask, so that it fades in and out when the video is playing/paused.
 * The component is also centered horizontally and vertically.
 */


const LiveLoadingCover = () => {
  const PlayerStore = getStore('playerStore');

  const hlsPlaybackReady = usePlayerStore((state) => state.hlsPlaybackReady);

  return (

    <Mask
      placement="center"
      themeOverride={{
        borderRadius: '0rem',
        background: 'rgba(255, 255, 255, 1)',
        zIndex: 7000,
      }}
    >
      <Loader spinnerSize="small"
        color="primary"
        textSize="medium"
        text='Loading live stream' />
    </Mask>

  );
};

export default LiveLoadingCover;
